module.exports = __webpack_public_path__ + "img/dunzo-logo.ad3ba1c8.svg";